export default __webpack_public_path__ + "static/media/Collection_Dark.b401b1f4.svg";